import { UserContext } from "@/context/User/UserContext";
import { getSinglePlatform } from "@/services/Platform.service";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import EditPlatform from "../dialog/EditPlatform";

const Platform = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const platform = useQuery({
		queryKey: ["platform", id],
		queryFn: () => getSinglePlatform(parseInt(id), user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});

	return (
		<>
			{platform.isLoading ? (
				<div className="grid gap-4 pt-4">
					{Array.from({ length: 2 }).map((_, num) => (
						<div key={num} className="h-12 w-full bg-gray-200 animate-pulse" />
					))}
				</div>
			) : platform.data ? (
				<>
					<div className="flex gap-3 items-end justify-between">
						<h1 className="font-medium text-4xl">
							Platform: {platform.data.platformname}
						</h1>
						<EditPlatform user={user} platform={platform.data} />
					</div>
					<div className="border-y my-3 py-4 border-zinc-200">
						<div className="grid grid-cols-1 sm:grid-cols-2">
							<div className="flex gap-4">
								<div className="flex flex-col gap-2 text-zinc-500 font-light text-nowrap">
									<p>ID</p>
									<p>Designation</p>
								</div>
								<div className="flex flex-col gap-2">
									<p>{platform.data.platformid}</p>
									<p>{platform.data.platformname}</p>
								</div>
							</div>
						</div>
					</div>
				</>
			) : null}
		</>
	);
};

export default Platform;
